import { render, staticRenderFns } from "./whisky-glass-ice.vue?vue&type=template&id=3fea2bc1"
import script from "./whisky-glass-ice.vue?vue&type=script&lang=js"
export * from "./whisky-glass-ice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports